module.exports = __webpack_public_path__ + "c6e23231ad7dfd2e1e3adbf9ab7ac26b.svg";